import { CopyRight } from "components/CopyRight";
import styled from "styled-components";

export const StyledCopyRight = styled(CopyRight)`
  display: flex;
  @media screen and (max-width: 1000px) {
    display: none;
  }
`;
